<template>
  <div class="puzzle-preview-container p-2 mt-2 border rounded bg-light">
    <div class="d-flex justify-content-between mb-2 align-items-center">
      <span class="small font-weight-bold text-muted">{{ title }}</span>
      <span class="badge badge-info">{{ columns }}x{{ rows }}</span>
    </div>

    <div class="preview-scroll-area">
      <puzzle-grid
        :table="table"
        :rows="rows"
        :columns="columns"
        :settings="{ puzzleTypeStyle: 'square' }"
        :cell-size="cellSize"
        :can-edit-questions="false"
      />
    </div>
  </div>
</template>
<script>
import PuzzleGrid from './PuzzleGrid.vue';

export default {
  name: 'PuzzlePreview',
  components: { PuzzleGrid },
  props: {
    title: {
      type: String,
      default: 'Preview do Grid:',
    },
    table: {
      type: Array,
      required: true,
    },
    rows: [Number, String],
    columns: [Number, String],
    cellSize: {
      type: Number,
      default: 40,
    },
  },
};
</script>
<style lang="scss" scoped>
.preview-scroll-area {
  max-height: 400px;
  overflow: auto;
  display: block;
  text-align: center;
  padding: 20px;
  border-radius: 4px;
}
</style>
